export const journeyCopyEs = {
    profileCompleteTitle: "Perfil completado",
    profileCompleteStatusLabel: "Perfil guardado",
    profileCompleteConsentDescription: "La información de su perfil se ha guardado. Pasaremos ahora al consentimiento.",
    profileCompleteSetupDescription:
        "La información de su perfil se ha guardado. Ahora necesitamos los detalles de su tratamiento.",
    profileCompleteFormsDescription:
        "La información de su perfil se ha guardado. Ahora puede cumplimentar sus formularios.",
    profileCompleteDiaryDescription: "La información de su perfil se ha guardado.",
    consentCompleteTitle: "Consentimiento completado",
    consentCompleteStatusLabel: "Consentimiento firmado",
    consentCompleteSetupDescription:
        "¡Gracias! Sus consentimientos se han registrado. Aún necesitamos alguna información adicional.",
    consentCompleteFormsDescription: "Sus consentimientos se han registrado. Ahora puede cumplimentar sus formularios.",
    consentCompleteDiaryDescription: "Sus consentimientos se han registrado.",
    setupCompleteTitle: "Configuración completada",
    setupCompleteStatusLabel: "Configuración guardada",
    setupCompleteConsentDescription: "Pasaremos ahora al consentimiento.",
    setupCompleteFormsDescription:
        "¡Gracias! Su información se ha guardado. Aún necesitamos alguna información adicional.",
    setupCompleteDiaryDescription: "Los detalles de su tratamiento están listos.",
    formCompleteTitle: "Formulario completado",
    formCompleteNextDescription: "Su respuesta se ha registrado. Puede pasar al siguiente registro.",
    formCompleteAllDoneDescription:
        "Su respuesta se ha registrado. Por el momento está al día. Puede consultar sus resultados.",
    formCompleteNextEntryDue: (scheduleLabel, date) =>
        `Su registro « ${scheduleLabel.toLowerCase()} » debe realizarse el ${date}.`,
    formCompleteStatusSuffix: "completado",
    continueToNextForm: "Siguiente",
    goToConsent: "Ir al consentimiento",
    goToSetup: "Ir a la configuración",
    knowProcedureDateYetTitle: "¿Ya conoce la fecha?",
    knowProcedureDateYetMessage:
        "Añada la fecha de su intervención en cuanto la conozca, para que las preguntas de seguimiento coincidan con su tratamiento.",
    addProcedureDate: "Añadir la fecha de la intervención",
    addHospitalNumber: "Añadir el número de historia clínica",
    addSide: "Añadir el lado",
    addEventDate: (eventPhrase) => `Añadir la fecha (${eventPhrase})`,
    reviewConsent: "Leer el consentimiento",
    shortcutsHeading: "Aún pendiente:",
    goToForms: "Ir a los formularios",
    goToYourDiary: "Ir a su diario",
    goToYourResults: "Ir a sus resultados",
    phaseProfile: "Perfil",
    phaseSetup: "Configuración",
    phaseConsent: "Consentimiento",
    phaseForms: "Formularios",
    phaseDiary: "Diario",
    setupHospitalNumber: "Número de historia clínica",
    setupProcedureDate: "Fecha de la intervención",
    setupSide: "Lado",
    loadingProgress: "Cargando el progreso...",
    progressTitle: "Su progreso",
    dismissProgress: "Cerrar el progreso",
    currentStage: "Fase actual",
    stepProgressAriaLabel: (stepLabel) => `Progreso: ${stepLabel}`,
    stepOf: "de",
    nextStep: "Siguiente paso",
    formsDoneCount: (done, total) => `Formularios completados: ${done} de ${total}`,
    diaryStillSettingUp: "Tu diario todavía se está configurando. Puede tardar un momento.",
    tryAgain: "Reintentar",
};
